import {handleError, handleResponse} from "./apiUtils";
import { persistAuthToken } from "./authTokenStorage";

const baseUrl = "https://uyygv3wln6.execute-api.eu-west-1.amazonaws.com/default/";

async function parseJsonBody(response) {
  const rawResponse = await response.text();
  if (!rawResponse) {
    return null;
  }

  try {
    return JSON.parse(rawResponse);
  } catch (error) {
    return rawResponse;
  }
}

function signUp(user) {
  return fetch(`${baseUrl}users/${user.id}`, {
    method: "PUT",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(user),
  })
    .then(handleResponse)
    .catch(handleError);
}

function signIn(user) {
  return fetch(`${baseUrl}login`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(user),
  })
    .then(handleResponse)
    .then((response) => {
      persistAuthToken(response.token);
      return response.user;
    })
    .catch(handleError);
}

async function signInWithGoogle(token) {
  const response = await fetch(`${baseUrl}login/google`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ token }),
  });

  const payload = await parseJsonBody(response);

  if (!response.ok) {
    const message = typeof payload === "string"
      ? payload
      : `Network response was not ok. status:${response.status}`;
    throw new Error(message);
  }

  persistAuthToken(payload.token);
  return payload.user;
}

function requestPasswordReset(email) {
  return fetch(`${baseUrl}password-reset/request`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ email }),
  })
    .then(handleResponse)
    .catch(handleError);
}

function confirmPasswordReset(token, password) {
  return fetch(`${baseUrl}password-reset/confirm`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ token, password }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export default {
  signUp,
  signIn,
  signInWithGoogle,
  requestPasswordReset,
  confirmPasswordReset,
};
